module.exports = __webpack_public_path__ + "static/media/P7181756.jpg.optimal.2a614f50.jpg";